module.exports = {
      id: "linkedinicon-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#linkedinicon",
      toString: function () {
        return this.url;
      }
    }